<template>
	<div>
		<template v-if="headerShow">
			<div class="data2">
				<div class="data2Left">
					<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item,index) in list.data.cover" :key="index">
								<div>
									<img :src="item" v-if="!list.data.type||list.data.type==1" :style="{
									height:list.data.height+'px'
								}" />
									<!-- <video :src="item" v-else :autoplay="true" muted loop :style="{
									height:list.data.height+'px'
								}"></video> -->
									<template v-else>
										<template v-if="headerShow">
											<video :src="item" :autoplay="true" muted loop :style="{
										height:list.data.height+'px'
									}"></video>
										</template>
										<template v-else>
											<video :src="item"  muted loop :style="{
										height:list.data.height+'px'
									}" x5-playsinline="true" controls preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
										</template>
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="data2Right" :style="{
					paddingRight:bj+'px'
				}">
					<div class="data2RightTil">{{list.data.menuTitle}}</div>
					<div class="data2RightBox">
						<div class="data2RightBoxFor" v-for="(item,index) in list.data.content" :key="index">
							<div class="data2RightBoxForImg">
								<img :src="item.cover" />
							</div>
							<div class="data2RightBoxForName">
								{{item.title}}
							</div>
							<div class="data2RightBoxForCen">
								<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="data2">
				<div class="data2Right" :style="{
					paddingRight:bj+'px'
				}">
					<div class="data2RightTil">{{list.data.menuTitle}}</div>
					<div class="data2RightBox">
						<div class="data2RightBoxFor" v-for="(item,index) in list.data.content" :key="index">
							<div class="data2RightBoxForImg">
								<img :src="item.cover" />
							</div>
							<div class="data2RightBoxForName">
								{{item.title}}
							</div>
							<div class="data2RightBoxForCen">
								<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="data2Left">
					<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item,index) in list.data.cover" :key="index">
								<div>
									<img :src="item" v-if="!list.data.type||list.data.type==1" :style="{
									height:list.data.height+'px'
								}" />
									<!-- <video :src="item" v-else :autoplay="true" muted loop :style="{
									height:list.data.height+'px'
								}"></video> -->
								<template v-else>
									<template v-if="headerShow">
										<video :src="item" :autoplay="true" muted loop :style="{
									height:list.data.height+'px'
								}" webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
									</template>
									<template v-else>
										<video :src="item"  muted loop :style="{
									height:list.data.height+'px'
								}" webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
									</template>
								</template>
								</div>
							</div>
						</div>
						<template v-if="!headerShow">
							<div class="swiper-hexin-prev"  :style="{
								left:`30px`,
								display:qhShow?activeIndex==0?'none':'block':'none'
							}" @click="prev()">
								<img src="@/assets/index/hxz.png" />
							</div>
							<div class="swiper-hexin-next" :style="{
								right:`30px`,
								display:qhShow?activeIndex==list.data.cover.length-1?'none':'block':'none'
							}" @click="next()">
								<img src="@/assets/index/hxy.png" />
							</div>
						</template>
					</div>
				</div>
				
			</div>
		</template>

	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				activeIndex: 0,
				bj: '',
				qhShow:true
				// list: [{
				// 		img: require('@/assets/product/njysddlzs.png'),
				// 	},
				// 	{
				// 		img: require('@/assets/product/njysddlzs.png'),
				// 	}
				// ],
				// njgfList: [{
				// 		img: require('@/assets/product/page9/txfd.png'),
				// 		name: '图像放大',
				// 		cen: '- 实现细节放大- 四档倍率可选'
				// 	},
				// 	{
				// 		img: require('@/assets/product/page9/usb.png'),
				// 		name: 'USB存储',
				// 		cen: '- 临床图像及视频随时存储'
				// 	},
				// 	{
				// 		img: require('@/assets/product/page9/xhdbzq.png'),
				// 		name: '血红蛋白增强',
				// 		cen: '- 高显色、强对比- 增强病变组织可能形成的粘膜血管形态'
				// 	},
				// 	{
				// 		img: require('@/assets/product/page9/dmstj.png'),
				// 		name: '多模式调节',
				// 		cen: '自动调光、手动调光模式满足更精细的光源精细调控要求-  峰值、均值、全自动测光3种模式，共含12阶的强化阶数'
				// 	},
				// ]
			}
		},
		mounted() {
			let t = this;
			this.getWidth();
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			let name = '.swiper-data2-banner' + this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				allowTouchMove: this.list.data.cover.length > 1 ? true : false,
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			this.$nextTick(function(){
				if(this.list.data.cover.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.urls.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.urls.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-data2-banner {
		overflow: hidden;
	}

	.swiper-slide {
		position: relative;

		img {
			width: 100%;
			height: 600px;
			object-fit: cover;
		}

		video {
			width: 100%;
			height: 600px;
			object-fit: contain;
		}
	}

	.data2 {
		display: flex;
		margin-bottom: 150px;
		width: 100%;

		.data2Left {
			width: 50%;
			margin-right: 70px;
			// background: #000000;
		}

		.data2Right {
			padding-right: 100px;
			flex: 1;
			min-width: 530px;

			.data2RightTil {
				font-size: 45px;
				
				font-weight: bold;
				color: #000000;
				margin-bottom: 70px;
			}

			.data2RightBox {
				display: flex;
				// align-items: center;
				flex-wrap: wrap;

				.data2RightBoxFor:nth-of-type(2n) {
					margin-left: 40px;
				}

				.data2RightBoxFor {
					width: 243px;
					margin-bottom: 58px;

					.data2RightBoxForImg {
						margin-bottom: 30px;

						img {
							width: 70px;
							height: 70px;
							object-fit: contain;
						}
					}

					.data2RightBoxForName {
						font-size: 26px;
						
						font-weight: 400;
						color: #000000;
						margin-bottom: 20px;
					}

					.data2RightBoxForCen {
						font-size: 18px;
						
						font-weight: 300;
						color: #000000;
						white-space: pre-line;
					}
				}
			}
		}
	}
	.swiper-data2-banner {
		overflow: hidden;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
	}
	@media screen and (max-width:1200px) {
		.data2 {
			margin-bottom: 0px !important;
			padding: 0 30px 30px !important;
			flex-wrap: wrap;
			box-sizing: border-box;
			.data2Left {
				min-width: 100% !important;
				margin-right: 0px !important;

				.swiper-slide {
					width: 100% !important;

					video {
						height: auto !important;
					}
				}

				img {
					height: auto !important;
				}
			}
			.data2Right{
				padding-right: 0 !important;
				min-width: 100% !important;
				padding-left: 0  !important;
				.data2RightTil{
					font-size: 24px !important;
					margin-bottom: 20px !important;
				}
				.data2RightBox{
					.data2RightBoxFor{
						margin-bottom: 20px !important;
						width: 42% !important;
						.data2RightBoxForImg {
							width: 40px;
							height: 40px;
							margin-bottom: 20px !important;
								
							img {
								width: 40px !important;
								height: 40px !important;
								object-fit: cover;
							}
						}
								
						.data2RightBoxForName {
							font-size: 18px !important;
							margin-bottom: 20px !important;
						}
								
						.data2RightBoxForCen {
							font-size: 14px !important;
						}
					}
				}
				
			}
		}
		.swiper-data2-banner{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
	}
</style>